// WHAT: Tab component for displaying insights with charts and breakdowns
// WHY:  Provides overview of time tracking insights with visualizations
// DOMAIN: Productivity → TimeTracQ
// DEPENDENCIES: InsightsChart, WorkspacesBreakdown components
// RISKS:
//   - NOTE: This is a simple wrapper - may need additional features
//   - NOTE: Layout is fixed - may not work well on small screens

import { InsightsChart } from "../../components/molecules/InsightsChart";
import { WorkspacesBreakdown } from "../../components/molecules/WorkspacesBreakdown";

/**
 * WHAT:
 *   Tab component that displays time tracking insights with charts and
 *   workspace breakdown visualizations.
 *
 * WHY:
 *   Provides centralized view for insights and analytics in the TimeTracQ
 *   application.
 *
 * BEHAVIOR:
 *   - Displays InsightsChart component
 *   - Displays WorkspacesBreakdown component
 *   - Uses vertical layout
 *
 * RISKS:
 *   - NOTE: This is a simple wrapper - may need additional features
 *   - NOTE: Layout is fixed - may not work well on small screens
 *
 * @returns JSX.Element
 *
 */
export const InsightsTab = () => {
  return (
    <div className="space-y-6">
      {/* NOTE: Upper level - Chart */}
      <InsightsChart />

      {/* NOTE: Lower level - Workspaces & Aspects */}
      <WorkspacesBreakdown />
    </div>
  );
};
